const SESSION_KEY_PREFIX = 'aiDashboardSessionId';
const CHAT_USER_SCOPE_STORAGE_KEY = 'qmetryAiChatUserScope';

const generateUuid = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : ((random & 0x3) | 0x8);
    return value.toString(16);
  });
};

const normalizeScopePart = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '') || 'anonymous';

const getDashboardSessionScope = () => {
  if (typeof window === 'undefined') {
    return 'anonymous';
  }

  try {
    const storedScope = sessionStorage.getItem(CHAT_USER_SCOPE_STORAGE_KEY);
    if (storedScope) {
      return storedScope;
    }
    const storedUserData = sessionStorage.getItem('userData');
    if (storedUserData) {
      const parsed = JSON.parse(storedUserData);
      return normalizeScopePart(parsed?.email || parsed?.name);
    }
  } catch (error) {
    // Ignore storage read failures and fall back to an anonymous scope.
  }

  return 'anonymous';
};

const buildSessionKey = () => `${SESSION_KEY_PREFIX}:${getDashboardSessionScope()}`;

export const generateDashboardSessionId = () => `dash-session-${generateUuid()}`;

export const getDashboardSessionId = () => {
  if (typeof window === 'undefined') {
    return generateDashboardSessionId();
  }

  try {
    const existingSessionId = sessionStorage.getItem(buildSessionKey());
    if (existingSessionId) {
      return existingSessionId;
    }
  } catch (error) {
    // Fall through and generate a fresh id if storage is unavailable.
  }

  const sessionId = generateDashboardSessionId();

  try {
    sessionStorage.setItem(buildSessionKey(), sessionId);
  } catch (error) {
    // Ignore storage failures and still return a stable in-memory value.
  }

  return sessionId;
};

export const clearDashboardSessionId = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const keysToRemove = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith(`${SESSION_KEY_PREFIX}:`)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    // Ignore cleanup errors.
  }
};

export default {
  getDashboardSessionId,
  generateDashboardSessionId,
  clearDashboardSessionId,
};
